import React, { FC } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { FormField } from "src/components/FormField";
import { FileField } from "src/components/FormField/FileField";
import { IFormField } from "src/@types/form";
import { cloneImagesFieldTrns } from "./trns";

export const CloneImagesField: FC<IFormField> = ({
  fieldClassName,
  labelClassName,
  name,
  label,
  ...props
}) => {
  const { t } = useTranslation();

  const [logo, mainPhoto] = name as [string, string];

  const fieldCombinedClassNames = cn(
    "flex !flex-row items-center justify-center gap-5",
    fieldClassName
  );

  return (
    <FormField
      className={fieldCombinedClassNames}
      labelClassName={labelClassName}
      label={label}
    >
      <FileField
        name={logo}
        placeholder={t(cloneImagesFieldTrns.logo)}
        {...props}
      />
      <FileField
        name={mainPhoto}
        placeholder={t(cloneImagesFieldTrns.mainPhoto)}
        {...props}
      />
    </FormField>
  );
};
